/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".warning-notify[data-count][_ngcontent-%COMP%]:after{position:absolute;right:50%;top:0;content:attr(data-count);font-size:.7rem;padding:.1rem .4rem;border-radius:999px;line-height:.7rem;color:#fff;background:rgba(255,0,0,.85);text-align:center;max-width:3rem}"];
export { styles as styles };
